import { apiSlice } from "@/services/api-slice";
import { APIResponse } from "@/types/custom-http";
import { Company, CreateCompany, UpdateCompany } from "./company.interface";


export const companyApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({

    getCompanies: builder.query<APIResponse<Company[]>,void>({
        query: () => ({
          url: "auth/company"
        }),
        providesTags: ["Company"],
    }),

    getCompanyById: builder.query<APIResponse<Company>,number>({
      query: (id) => ({ url:`/users/${id}`}),
      providesTags: (_result, _error, id) => [{ type: 'Company', id }],
    }),
    
    // Crear un nuevo usuario
    createCompany: builder.mutation<APIResponse<Company>, CreateCompany>({
      query: (data) => ({
        url: 'auth/company',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Company'],
    }),

    updateCompany: builder.mutation<APIResponse<Company>, { id: number; changes: UpdateCompany }>({
      query: ({ id, changes }) => ({
        url: `auth/company/${id}`,
        method: 'PATCH',
        body: changes,
      }),
      invalidatesTags: (_result, _error, { id }) => [{ type: 'Company', id },'Company'],
    })

  }),

});


// Exportar hooks generados
export const {
  useGetCompaniesQuery,
  useGetCompanyByIdQuery,
  useCreateCompanyMutation,
  useUpdateCompanyMutation
} = companyApi;